import React, { useCallback, useLayoutEffect, useMemo, useState } from 'react';
import { Spacing } from 'apps/sigma2-ui/src/components/ui/Spacing';
import { HorizontalFilterBar } from 'apps/sigma2-ui/src/filters-v2/components/HorizontalFilterBar';
import { useFilters } from 'apps/sigma2-ui/src/filters-v2/lib/useFilters';
import { useObservation } from 'apps/sigma2-ui/src/state/observation';
import { RichTextComponentSerializableProps } from 'libs/end-to-end/src/custom-viz/RichTextTypes';
import { RichTextCustomVizDefinition } from 'libs/end-to-end/src/custom-viz/RichTextDefinition';
import { RichTextOutput } from 'libs/end-to-end/src/custom-viz/RichTextTypes';
import { RichTextRequest } from 'libs/end-to-end/src/custom-viz/RichTextTypes';
import { Content } from '@tiptap/react';
import { Editor } from '@tiptap/react';
import { EditorContent } from '@tiptap/react';
import { EditorContext } from '@tiptap/react';
import { useEditor } from '@tiptap/react';
import { RichTextButton } from 'apps/sigma2-ui/src/components/rich-text/tiptap/components/tiptap-ui-primitive/button/button';
import { RichTextSpacer } from 'apps/sigma2-ui/src/components/rich-text/tiptap/components/tiptap-ui-primitive/spacer/spacer';
import { RichTextToolbar } from 'apps/sigma2-ui/src/components/rich-text/tiptap/components/tiptap-ui-primitive/toolbar/toolbar';
import { RichTextToolbarGroup } from 'apps/sigma2-ui/src/components/rich-text/tiptap/components/tiptap-ui-primitive/toolbar/toolbar';
import { RichTextToolbarSeparator } from 'apps/sigma2-ui/src/components/rich-text/tiptap/components/tiptap-ui-primitive/toolbar/toolbar';
import { RichTextHeadingDropdownMenu } from 'apps/sigma2-ui/src/components/rich-text/tiptap/components/tiptap-ui/heading-dropdown-menu/heading-dropdown-menu';
import { RichTextListDropdownMenu } from 'apps/sigma2-ui/src/components/rich-text/tiptap/components/tiptap-ui/list-dropdown-menu/list-dropdown-menu';
import { RichTextBlockQuoteButton } from 'apps/sigma2-ui/src/components/rich-text/tiptap/components/tiptap-ui/blockquote-button/blockquote-button';
import { RichTextCodeBlockButton } from 'apps/sigma2-ui/src/components/rich-text/tiptap/components/tiptap-ui/code-block-button/code-block-button';
import { RichTextColorHighlightPopover } from 'apps/sigma2-ui/src/components/rich-text/tiptap/components/tiptap-ui/color-highlight-popover/color-highlight-popover';
import { RichTextColorHighlightPopoverContent } from 'apps/sigma2-ui/src/components/rich-text/tiptap/components/tiptap-ui/color-highlight-popover/color-highlight-popover';
import { RichTextColorHighlightPopoverButton } from 'apps/sigma2-ui/src/components/rich-text/tiptap/components/tiptap-ui/color-highlight-popover/color-highlight-popover';
import { RichTextLinkPopover } from 'apps/sigma2-ui/src/components/rich-text/tiptap/components/tiptap-ui/link-popover/link-popover';
import { RichTextLinkContent } from 'apps/sigma2-ui/src/components/rich-text/tiptap/components/tiptap-ui/link-popover/link-popover';
import { RichTextLinkButton } from 'apps/sigma2-ui/src/components/rich-text/tiptap/components/tiptap-ui/link-popover/link-popover';
import { RichTextMarkButton } from 'apps/sigma2-ui/src/components/rich-text/tiptap/components/tiptap-ui/mark-button/mark-button';
import { RichTextTextAlignButton } from 'apps/sigma2-ui/src/components/rich-text/tiptap/components/tiptap-ui/text-align-button/text-align-button';
import { RichTextUndoRedoButton } from 'apps/sigma2-ui/src/components/rich-text/tiptap/components/tiptap-ui/undo-redo-button/undo-redo-button';
import { RichTextArrowLeftIcon } from 'apps/sigma2-ui/src/components/rich-text/tiptap/components/tiptap-icons/arrow-left-icon';
import { RichTextHighlighterIcon } from 'apps/sigma2-ui/src/components/rich-text/tiptap/components/tiptap-icons/highlighter-icon';
import { RichTextLinkIcon } from 'apps/sigma2-ui/src/components/rich-text/tiptap/components/tiptap-icons/link-icon';
import { useRichTextMobile } from 'apps/sigma2-ui/src/components/rich-text/tiptap/hooks/use-mobile';
import { useRichTextWindowSize } from 'apps/sigma2-ui/src/components/rich-text/tiptap/hooks/use-window-size';
import { useRichTextCursorVisibility } from 'apps/sigma2-ui/src/components/rich-text/tiptap/hooks/use-cursor-visibility';
import 'apps/sigma2-ui/src/components/rich-text/tiptap/styles/_variables.scss';
import 'apps/sigma2-ui/src/components/rich-text/tiptap/styles/_keyframe-animations.scss';
import 'apps/sigma2-ui/src/components/rich-text/tiptap/components/tiptap-node/code-block-node/code-block-node.scss';
import 'apps/sigma2-ui/src/components/rich-text/tiptap/components/tiptap-node/list-node/list-node.scss';
import 'apps/sigma2-ui/src/components/rich-text/tiptap/components/tiptap-node/paragraph-node/paragraph-node.scss';
import 'apps/sigma2-ui/src/components/rich-text/RichTextEditor.scss';
import { Spinner } from 'apps/sigma2-ui/src/components/ui/Spinner';
import { CustomVizHookResult } from 'apps/sigma2-ui/src/lib/custom-viz/types';
import { CustomVizHookStatus } from 'apps/sigma2-ui/src/lib/custom-viz/types';
import { parseCustomVizResult } from 'apps/sigma2-ui/src/lib/hooks/useCustomVizAutoload';
import { ExplorePageFailure } from 'apps/sigma2-ui/src/explore-section/components/ExplorePageFailure';
import { Box } from 'apps/sigma2-ui/src/components/ui/Box';
import { CustomVizCircularSpinner } from 'apps/sigma2-ui/src/components/ui/CustomVizCircularSpinner';
import { useUser } from 'apps/sigma2-ui/src/state/user';
import { CustomViz } from 'apps/sigma2-ui/src/components/custom-viz/CustomViz';
import { noop } from 'lodash';
import { useUserObservationOrgAndDbIds } from 'apps/sigma2-ui/src/lib/hooks/useUserObservationOrgAndDbIds';
import { createRichTextEditorExtensions } from 'apps/sigma2-ui/src/lib/custom-viz/rich-text';
import { deserializeRichTextContent } from 'apps/sigma2-ui/src/lib/custom-viz/rich-text';

const MainToolbarContent = ({
  onHighlighterClick,
  onLinkClick,
  isMobile,
}: {
  onHighlighterClick: () => void;
  onLinkClick: () => void;
  isMobile: boolean;
}) => {
  return (
    <>
      <RichTextSpacer />

      <RichTextToolbarGroup>
        <RichTextUndoRedoButton action="undo" />
        <RichTextUndoRedoButton action="redo" />
      </RichTextToolbarGroup>

      <RichTextToolbarSeparator />

      <RichTextToolbarGroup>
        <RichTextHeadingDropdownMenu levels={[1, 2, 3, 4]} />
        <RichTextListDropdownMenu
          types={['bulletList', 'orderedList', 'taskList']}
        />
        <RichTextBlockQuoteButton />
        <RichTextCodeBlockButton />
      </RichTextToolbarGroup>

      <RichTextToolbarSeparator />

      <RichTextToolbarGroup>
        <RichTextMarkButton type="bold" />
        <RichTextMarkButton type="italic" />
        <RichTextMarkButton type="strike" />
        <RichTextMarkButton type="code" />
        <RichTextMarkButton type="underline" />
        {!isMobile ? (
          <RichTextColorHighlightPopover />
        ) : (
          <RichTextColorHighlightPopoverButton onClick={onHighlighterClick} />
        )}
        {!isMobile ? (
          <RichTextLinkPopover />
        ) : (
          <RichTextLinkButton onClick={onLinkClick} />
        )}
      </RichTextToolbarGroup>

      <RichTextToolbarSeparator />

      <RichTextToolbarGroup>
        <RichTextMarkButton type="superscript" />
        <RichTextMarkButton type="subscript" />
      </RichTextToolbarGroup>

      <RichTextToolbarSeparator />

      <RichTextToolbarGroup>
        <RichTextTextAlignButton align="left" />
        <RichTextTextAlignButton align="center" />
        <RichTextTextAlignButton align="right" />
        <RichTextTextAlignButton align="justify" />
      </RichTextToolbarGroup>

      <RichTextToolbarSeparator />

      <RichTextSpacer />

      {isMobile && <RichTextToolbarSeparator />}
    </>
  );
};

const MobileToolbarContent = ({
  type,
  onBack,
}: {
  type: 'highlighter' | 'link';
  onBack: () => void;
}) => (
  <>
    <RichTextToolbarGroup>
      <RichTextButton data-style="ghost" onClick={onBack}>
        <RichTextArrowLeftIcon className="tiptap-button-icon" />
        {type === 'highlighter' ? (
          <RichTextHighlighterIcon className="tiptap-button-icon" />
        ) : (
          <RichTextLinkIcon className="tiptap-button-icon" />
        )}
      </RichTextButton>
    </RichTextToolbarGroup>

    <RichTextToolbarSeparator />

    {type === 'highlighter' ? (
      <RichTextColorHighlightPopoverContent />
    ) : (
      <RichTextLinkContent />
    )}
  </>
);

export const RichTextEditorPure = ({
  content,
  isLoading,
  isEditable,
  onApply,
}: RichTextComponentSerializableProps & {
  onApply: (editor: Editor) => void;
}) => {
  const isMobile = useRichTextMobile();
  const windowSize = useRichTextWindowSize();
  const [mobileView, setMobileView] = React.useState<
    'main' | 'highlighter' | 'link'
  >('main');
  const toolbarRef = React.useRef<HTMLDivElement>(null);

  const editor = useEditor({
    immediatelyRender: false,
    editorProps: {
      attributes: {
        autocomplete: 'off',
        autocorrect: 'off',
        autocapitalize: 'off',
        'aria-label': 'Main content area, start typing to enter text.',
      },
    },
    extensions: createRichTextEditorExtensions(),
    content: deserializeRichTextContent(content) ?? undefined,
    editable: isEditable,
    onUpdate: ({ editor }) => onApply?.(editor),
    onCreate: ({ editor }) =>
      editor.commands.setFontFamily(`Karla,
    'Trebuchet MS',
    ui-sans-serif,
    -apple-system,
    'system-ui',
    'Helvetica Neue',
    'Segoe UI',
    Arial,
    Roboto,
    Oxygen,
    Ubuntu,
    Cantarell,
    sans-serif`),
  });

  const [overlayHeight, setOverlayHeight] = useState(0);

  useLayoutEffect(() => {
    if (!toolbarRef.current) return;

    setOverlayHeight(toolbarRef.current.getBoundingClientRect().height);
  }, []);

  const bodyRect = useRichTextCursorVisibility({
    editor,
    overlayHeight,
  });

  React.useEffect(() => {
    if (!isMobile && mobileView !== 'main') {
      setMobileView('main');
    }
  }, [isMobile, mobileView]);

  return (
    <>
      {isLoading ? (
        <Spinner />
      ) : (
        <EditorContext.Provider value={{ editor }}>
          <>
            {isEditable && (
              <RichTextToolbar
                ref={toolbarRef}
                style={
                  isMobile
                    ? {
                        bottom: `calc(100% - ${windowSize.height - bodyRect.y}px)`,
                      }
                    : {}
                }
              >
                {mobileView === 'main' ? (
                  <MainToolbarContent
                    onHighlighterClick={() => setMobileView('highlighter')}
                    onLinkClick={() => setMobileView('link')}
                    isMobile={isMobile}
                  />
                ) : (
                  <MobileToolbarContent
                    type={mobileView === 'highlighter' ? 'highlighter' : 'link'}
                    onBack={() => setMobileView('main')}
                  />
                )}
              </RichTextToolbar>
            )}

            <div
              className={
                isEditable
                  ? 'content-wrapper'
                  : 'content-wrapper content-wrapper-no-toolbar'
              }
            >
              <EditorContent
                editor={editor}
                role="presentation"
                className="simple-editor-content"
              />
            </div>
          </>
        </EditorContext.Provider>
      )}
    </>
  );
};

export const RichTextEditorCard = ({
  result,
  status,
  isEditable,
  onApply,
}: {
  result: CustomVizHookResult;
  status: CustomVizHookStatus;
  isEditable?: boolean;
  onApply?: (editor: Editor) => void;
}) => {
  const { isLoading, data, hasFailed } = useMemo(
    () =>
      parseCustomVizResult({
        result,
        status,
        ResultZodType: RichTextOutput,
      }),
    [result, status],
  );

  if (hasFailed && !isLoading) {
    return <ExplorePageFailure />;
  }

  if (isLoading || !data) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        h="full"
        w="full"
      >
        <CustomVizCircularSpinner />
      </Box>
    );
  }

  return (
    <RichTextEditorPure
      key={String(isEditable)}
      content={data.serializedContent}
      isLoading={isLoading}
      isEditable={isEditable ?? false}
      onApply={onApply || noop}
    />
  );
};

export const RichTextEditorStateful = () => {
  const { myObservation } = useObservation();
  const { selectedOrganizationId } = useUserObservationOrgAndDbIds();
  const [content, setContent] = useState<Content>(null);
  const [plainText, setPlainText] = useState<string>();

  const getCustomVizRequest = useCallback((): {
    customVizRequest: RichTextRequest | undefined;
  } => {
    if (!myObservation || !selectedOrganizationId) {
      return { customVizRequest: undefined };
    }

    const customVizRequest: RichTextRequest = {
      customVizId: 'richText',
      inputs: {
        extras: {
          richText: {
            serializedContent: JSON.stringify(content),
            plainText: plainText ?? '',
          },
        },
        dropdowns: {},
      },
      observationLocationType: myObservation.type,
      organizationId: selectedOrganizationId,
    };

    return {
      customVizRequest,
    };
  }, [myObservation, selectedOrganizationId, content, plainText]);

  const filterPayload = useFilters({
    feature: 'richText',
    focusArea: null,
    disabled: false,
    metricDefinitionWhiteLabeling: null,
    onApply: () => {},
    getCustomVizRequest,
    analysisName: undefined,
  });

  const contentSerialized = useMemo(() => JSON.stringify(content), [content]);

  return (
    <div>
      <Spacing direction="vertical" size="md">
        <HorizontalFilterBar items={filterPayload.items} />
        <RichTextEditorPure
          content={contentSerialized}
          isLoading={false}
          isEditable={true}
          onApply={(editor) => {
            setContent(editor.getJSON());
            setPlainText(editor.getText());
          }}
        />
      </Spacing>
    </div>
  );
};

export const RichTextEditorFull = () => {
  const { myUser, userAuthenticatedApiCall } = useUser();
  const { myObservation } = useObservation();

  const {
    selectedOrganizationId,
    selectedDatabaseId,
    selectedDatabaseRevisionId,
  } = useUserObservationOrgAndDbIds();

  if (
    !myObservation ||
    !selectedDatabaseRevisionId ||
    !selectedDatabaseId ||
    !selectedOrganizationId ||
    !myUser
  ) {
    return <></>;
  }

  return (
    <CustomViz
      observation={myObservation.type}
      organizationId={selectedOrganizationId}
      customVizDefinition={RichTextCustomVizDefinition}
      userAuthenticatedApiCall={userAuthenticatedApiCall}
    >
      <RichTextEditorStateful />
    </CustomViz>
  );
};
